namespace TabAurous.Production {
    export interface MFGInspectionValuesRow {
        TransInspectionId?: number;
        TransItemId?: number;
        Parameter?: string;
        ExpectedValue?: string;
        InspectedValue?: string;
        Status?: boolean;
        Min?: string;
        Max?: string;
        Remark?: string;
    }

    export namespace MFGInspectionValuesRow {
        export const idProperty = 'TransInspectionId';
        export const nameProperty = 'Parameter';
        export const localTextPrefix = 'Production.MFGInspectionValues';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            TransInspectionId = "TransInspectionId",
            TransItemId = "TransItemId",
            Parameter = "Parameter",
            ExpectedValue = "ExpectedValue",
            InspectedValue = "InspectedValue",
            Status = "Status",
            Min = "Min",
            Max = "Max",
            Remark = "Remark"
        }
    }
}
